module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplay900italic.83e2c6ec.ttf";